(function($) {
  var isIE =  (typeof document.createElement("span").dragDrop === "function");

  var detectLeftButton = Pegasus.Helpers.detectLeftButtonDepressed;

  $.fn.customDragImage = function(options) {
    var offsetX = options.offsetX || 0,
      offsetY = options.offsetY || 0;

    var createDragImage = function($node, x, y) {
      var $img = $(options.createDragImage($node));
      $img.css({
        zIndex: 999999,
        top: Math.max(0, y-offsetY)+"px",
        left: Math.max(0, x-offsetX)+"px",
        position: "fixed",
        pointerEvents: "none"
      }).appendTo(document.body);

      setTimeout(function() {
        $img.remove();
      });

      return $img[0];
    };

    if (isIE) {
      $(this).off("mousemove.drag").on("mousemove.drag", function(e) {
        // don't drag if we are trying to select text in a ckeditor instance
        if ( $(e.target).closest('.cke_editable').length ) { return; }

        if ( detectLeftButton(e) ) {
          var originalEvent = e.originalEvent,
            node = createDragImage($(this), originalEvent.pageX, originalEvent.pageY);

          node.dragDrop();
        }
      });
    }

    $(this).off("dragstart.drag").on("dragstart.drag", function(e) {
      var originalEvent = e.originalEvent,
        dt = originalEvent.dataTransfer;

      dt.setData('text', 'some');

      if (typeof dt.setDragImage === "function") {
        node = createDragImage($(this), originalEvent.pageX, originalEvent.pageY);
        dt.setDragImage(node, offsetX, offsetY);
      }
    });

    return this;
  };
})(jQuery);

(function(){
  var instance;
  var originalOpacity;
  var command;
  var isAddition = false;

  Pegasus.DragManager = Em.Controller.extend({
    handleDragStart: function(e){
      var source = e.target,
        cookie;

      if ( ! source || ! source.draggable ) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      e.dataTransfer.setData( "text", source.dataset.blockLibraryIdentifier );
      e.dataTransfer.effectAllowed = 'move';

      var callback = function(){
        //debugger;
      };

      isAddition = true;
    },

    handleDragEnd: function(e){},

    handleDragOver: function(e) {
      if (e.preventDefault) {
        e.preventDefault(); // Necessary. Allows us to drop.
      }

      e.dataTransfer.dropEffect = 'move';  // See the section on the DataTransfer object.

      return false;
    },

    handleDragEnter: function (e) {
      var row = $(e.target).closest('.vr-row');
      var apcController = Pegasus.lookupController('activePortionControl');

      if ( row.length ) {
        row = Em.View.views[ row[0].id ];
        apcController.set('row', row);
      }
      // future story
    },

    handleDragLeave: function (e) {
      // future story
    },

    init: function(){
      this._super();

      window.addEventListener('dragstart', this.handleDragStart, false);
      window.addEventListener('dragenter', this.handleDragEnter, false)
      window.addEventListener('dragover', this.handleDragOver, false);
      window.addEventListener('dragleave', this.handleDragLeave, false);
      window.addEventListener('dragend', this.handleDragEnd, false);
    }
  });

  Pegasus.DragManager.reopenClass({
    create: function(){
      if ( instance ) {
        return instance;
      }
      var result = this._super.apply(this, arguments);
      instance = result;

      return instance;
    },
    getInstance: function(){
      return Pegasus.DragManager.create();
    }
  });
})();

Pegasus.DragManager.getInstance();
